import axios from 'axios';

// 创建 Axios 实例
const instance = axios.create({
	//baseURL: 'http://192.168.50.46:8000/', // 替换为你的实际请求地址
	baseURL: 'https://app.niubeidata.com/', // 替换为你的实际请求地址
	timeout: 60000, // 超时时间
});

// 定义最大重试次数和初始重试间隔时间
const MAX_RETRIES = 2;

// 拦截器：响应错误处理
instance.interceptors.response.use(
	response => response, // 正常响应直接返回
	async (error) => {
		const config = error.config;

		// 确保错误配置可以重试
		if (!config || config.__retryCount >= MAX_RETRIES) {
			return Promise.reject(error);
		}

		// 增加重试计数
		config.__retryCount = config.__retryCount || 0;
		config.__retryCount += 1;

		// 计算等待时间（每次增加 1 秒）
		const retryDelay = config.__retryCount * 1000;

		// 等待指定的时间后再重试
		await new Promise(resolve => setTimeout(resolve, retryDelay));

		// 重试请求
		return instance(config);
	}
)
export default instance
